const SSO_BASE = "https://www.niroggyan.com";

/**
 * Check SSO session via test-auth. Does not redirect; returns user or null.
 * Caller (ClientAuthGuard) decides redirect to same-origin /login when needed.
 */
export async function checkClientAuth() {
  try {
    const res = await fetch(`${SSO_BASE}/api/auth/test-auth`, {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });

    if (res.status === 401 || !res.ok) {
      return null;
    }

    const data = await res.json();

    if (!data || data.authenticated !== true || !data.user) {
      return null;
    }

    // Accept any role (lab, admin, user, etc.)
    return data.user;
  } catch (error) {
    console.error("checkClientAuth failed", error);
    return null;
  }
}

/**
 * Check if user has in-app login (localStorage loginDetails from LoginPage).
 * Used to allow login both via SSO and via the site's own login form.
 */
export function hasLocalLogin() {
  try {
    const raw = localStorage.getItem("loginDetails");
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && Object.keys(parsed).length > 0;
  } catch {
    return false;
  }
}

export async function ssoLogout() {
  try {
    await fetch(`${SSO_BASE}/api/auth/logout`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("ssoLogout failed", error);
  } finally {
    window.location.href = "/login";
  }
}
